<div
  class="container-fluid"
  [ngClass]="{ 'component-loading': loading }"
  [ngStyle]="{
    'min-height': data?.length === 0 && !loading ? '80vh' : null,
  }"
>
  @if (data?.length === 0) {
    <div
      style="
        margin-top: auto;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
      "
    >
      <ds-empty-state />
    </div>
  } @else {
    <p-table
      class="p-table books-review-table"
      [value]="data"
      dataKey="code"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr class="t-head">
          <!-- <th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th> -->
          <th pSortableColumn="code">
            PAYEE <p-sortIcon field="code"></p-sortIcon>
          </th>
          <th>DESCRIPTION</th>
          <th pSortableColumn="name">
            DATE <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="category">
            AMOUNT <p-sortIcon field="category"></p-sortIcon>
          </th>
          <th pSortableColumn="quantity">
            ACCOUNT <p-sortIcon field="quantity"></p-sortIcon>
          </th>
          <th pSortableColumn="price">
            CLASS <p-sortIcon field="price"></p-sortIcon>
          </th>
          <th pSortableColumn="code">ACTIONS</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="t-row">
          <!-- <td>
            <p-tableCheckbox [value]="item"></p-tableCheckbox>
          </td> -->
          <td>
            {{ item.payee }}
          </td>
          <td>
            @if (item.description) {
              <i class="feather info" tooltip="{{ item.description }}"></i>
            }
          </td>
          <td style="white-space: nowrap">
            {{ item.payment_date | amDateFormat: "MMM DD, YYYY" }}
          </td>
          <td class="text-end">{{ item.amount | currency: "USD" }}</td>
          <td>
            {{ item.selectedAcc }}
          </td>

          <td>
            {{ item.class }}
          </td>
          <td>
            <div class="actions">
              <button class="btn btn-primary" (click)="createClientTask(item)">
                Create Client Task
              </button>
              <button
                class="btn btn-link px-3 ms-3"
                (click)="markTransactionAsReviewed(item, 'purchase_id')"
                tooltip="Mark as reviewed"
              >
                <i class="tio-checkmark_square_outlined fs-5"></i>
              </button>

              <div
                class="btn-group d-inline-block"
                dropdown
                [autoClose]="true"
                placement="bottom right"
                container="body"
              >
                <button
                  dropdownToggle
                  class="btn btn-icon rounded px-3"
                  tooltip="More"
                >
                  <i class="tio-more_horizontal fs-5"></i>
                </button>
                <ul
                  id="dropdown-basic"
                  *dropdownMenu
                  class="dropdown-menu dropdown-menu-right"
                  role="menu"
                  aria-labelledby="button-basic"
                >
                  <!-- <li role="menuitem">
                    <a class="dropdown-item">Detailed View</a>
                  </li> -->
                  <li
                    role="menuitem"
                    (click)="
                      booksReviewService.goToQuickBooks(
                        item.purchase_id,
                        item.txn_type
                      )
                    "
                  >
                    <a class="dropdown-item">Open in QuickBooks</a>
                  </li>
                  <!-- <li role="menuitem">
                    <a class="dropdown-item">Create client task</a>
                  </li>
                  <li role="menuitem">
                    <a class="dropdown-item" [pRowToggler]="item"
                      >Similar transactions</a
                    >
                  </li> -->
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
